/* ==========================================================================
   BALMiso Theme — JavaScript
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Header scroll effect ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      header.classList.toggle('is-scrolled', currentScroll > 10);
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.classList.toggle('is-active');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  document.querySelectorAll('.mobile-menu__link, .search-overlay__close').forEach((el) => {
    el.addEventListener('click', () => {
      if (mobileMenu) mobileMenu.classList.remove('is-open');
      if (menuToggle) menuToggle.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  });

  /* ---------- Search overlay ---------- */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('.search-overlay__input');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('is-open');
      if (searchInput) searchInput.focus();
    }
  }

  function closeSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('is-open');
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawerCloseButtons = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer(e) {
    if (cartDrawer) {
      e.preventDefault();
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  cartDrawerCloseButtons.forEach((btn) => {
    btn.addEventListener('click', closeCartDrawer);
  });

  /* ---------- Product accordions ---------- */
  document.querySelectorAll('[data-accordion]').forEach((accordion) => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    if (trigger) {
      trigger.addEventListener('click', () => {
        const isOpen = accordion.classList.contains('is-open');

        // Close all others
        accordion.parentElement.querySelectorAll('[data-accordion]').forEach((a) => {
          a.classList.remove('is-open');
        });

        if (!isOpen) {
          accordion.classList.add('is-open');
        }
      });
    }
  });

  /* ---------- Product thumbnails ---------- */
  const thumbs = document.querySelectorAll('[data-thumb-index]');
  const mainImg = document.getElementById('product-main-img');
  const dots = document.querySelectorAll('[data-dot-index]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-thumb-src');
      const index = thumb.getAttribute('data-thumb-index');

      if (mainImg) mainImg.src = src;

      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      dots.forEach((d) => d.classList.remove('is-active'));
      const activeDot = document.querySelector(`[data-dot-index="${index}"]`);
      if (activeDot) activeDot.classList.add('is-active');
    });
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = dot.getAttribute('data-dot-index');
      const thumb = document.querySelector(`[data-thumb-index="${index}"]`);
      if (thumb) thumb.click();
    });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;

      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then(() => {
          submitBtn.textContent = 'Added!';

          // Update cart count
          fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
              const countEls = document.querySelectorAll('[data-cart-count]');
              countEls.forEach((el) => (el.textContent = cart.item_count));
            });

          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        })
        .catch(() => {
          submitBtn.textContent = 'Error';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        });
    });
  });

  /* ---------- Scroll animations (IntersectionObserver) ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const animatedElements = document.querySelectorAll(
      '.hero-banner__content, .section-header, .product-card, .designed-for__content, .designed-for__image, .pure-ingredients__item, .aromatherapeutic__item, .start-ritual__card'
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    animatedElements.forEach((el, index) => {
      el.style.transitionDelay = `${index * 0.05}s`;
      observer.observe(el);
    });
  }

    /* ---------- Spotlight carousel ---------- */
  document.querySelectorAll('[data-spotlight-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-spotlight-track]');
    const prev = carousel.querySelector('[data-spotlight-prev]');
    const next = carousel.querySelector('[data-spotlight-next]');
    if (!track || !prev || !next) return;

    function getStep() {
      const firstSlide = track.querySelector('.spotlight-products__slide');
      if (!firstSlide) return 320;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstSlide.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });

  /* ---------- Collection filter selects ---------- */
  document.querySelectorAll('[data-filter-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);

      document.querySelectorAll('[data-filter-select]').forEach((s) => {
        if (s.value) {
          const [key, value] = s.value.split('=');
          params.set(key, value);
        }
      });

      window.location.search = params.toString();
    });
  });
})();
